export default __webpack_public_path__ + "static/media/left-bg.bab946f1.png";